import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import PasswordModal from './class_SecurityModal';
import { useState } from 'react';

const SpeakingModule = ({ module, moduleIndex, expandedModules, toggleModule, expandedClasses, toggleClass }) => {
    const navigate = useNavigate();
    const [modalOpen, setModalOpen] = useState(false);
    const [pendingClass, setPendingClass] = useState(null);
    const [pendingClassName, setPendingClassName] = useState('');

    // ক্লাস ইনডেক্স থেকে env key map
    const classKeyMap = [
        'SPK01_PART1', 'SPK02_CUECARD', 'SPK03_PART3'
    ];

    const handleClassClick = (moduleIdx, classIdx, className) => {
        setPendingClass({ moduleIdx, classIdx });
        setPendingClassName(className);
        setModalOpen(true);
    };

    const handlePasswordSuccess = () => {
        if (pendingClass) {
            toggleClass(pendingClass.moduleIdx, pendingClass.classIdx);
        }
        setModalOpen(false);
        setPendingClass(null);
        setPendingClassName('');
    };

    const handleModalClose = () => {
        setModalOpen(false);
        setPendingClass(null);
        setPendingClassName('');
    };

    return (
        <div className="bg-white rounded-xl shadow-md overflow-hidden">
            {/* Module Header */}
            <div
                onClick={() => toggleModule(moduleIndex)}
                className="flex justify-between items-center px-6 py-4 cursor-pointer hover:bg-gray-100 transition"
            >
                <h2 className="text-xl font-semibold text-[#001670]">{module.name}</h2>
                {expandedModules[moduleIndex] ? (
                    <FaChevronUp className="text-[#001670]" />
                ) : (
                    <FaChevronDown className="text-[#001670]" />
                )}
            </div>

            {/* Expanded Module Content */}
            {expandedModules[moduleIndex] && (
                <div className="px-6 pb-4 space-y-2">
                    {module.classes.map((classItem, classIndex) => {
                        const subKey = `${moduleIndex}-${classIndex}`;
                        return (
                            <div key={classIndex} className="border rounded-md">
                                {/* Speaking Class Header */}
                                <div
                                    className="flex justify-between items-center px-4 py-3 bg-gray-50 cursor-pointer hover:bg-gray-100 transition"
                                    onClick={() => handleClassClick(moduleIndex, classIndex, classItem.name)}
                                >
                                    <h3 className="font-medium text-[#001670]">{classItem.name}</h3>
                                    {expandedClasses[subKey] ? (
                                        <FaChevronUp className="text-[#001670]" />
                                    ) : (
                                        <FaChevronDown className="text-[#001670]" />
                                    )}
                                </div>
                                {/* Speaking Class Expanded Content */}
                                {expandedClasses[subKey] && (
                                    <div className="pl-6 py-2 space-y-2">
                                        {/* 1. Class Lecture - Not Clickable */}
                                        <div className="flex items-center space-x-2">
                                            <span className="text-lg">&#x25B8;</span>
                                            <span className="font-semibold text-lg">{classItem.subClasses[0]}</span>
                                        </div>
                                        {/* 2. Guided Practice 01 - Clickable */}
                                        <div className="flex items-center space-x-2 cursor-pointer hover:bg-gray-200"
                                            onClick={() => navigate(`/class-0${classIndex + 1}-speaking`, {
                                                state: { target: 'guided-practice-01' }
                                            })}
                                        >
                                            <span className="text-lg">&#x25B8;</span>
                                            <span className="font-semibold text-lg">{classItem.subClasses[1]}</span>
                                        </div>
                                        {/* 3. Guided Practice 02 - Clickable */}
                                        <div className="flex items-center space-x-2 cursor-pointer hover:bg-gray-200"
                                            onClick={() => navigate(`/class-0${classIndex + 1}-speaking`, {
                                                state: { target: 'guided-practice-02' }
                                            })}
                                        >
                                            <span className="text-lg">&#x25B8;</span>
                                            <span className="font-semibold text-lg">{classItem.subClasses[2]}</span>
                                        </div>
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>
            )}
            <PasswordModal
                isOpen={modalOpen}
                onSubmit={handlePasswordSuccess}
                onClose={handleModalClose}
                classKey={classKeyMap[pendingClass?.classIdx]}
                className={pendingClassName}
            />
        </div>
    );
};

export default SpeakingModule; 